import { FileTypes } from "./FileTypes";

// Must match: Src\MainSolution\Airsweb.Common.Constants\FileTypes.cs
export const FileTypeDescriptions = new Map<FileTypes, string>([
    [FileTypes.CSV, "CSV"],
    [FileTypes.Image, "Image"],
    [FileTypes.PDF, "PDF"],
    [FileTypes.Presentation, "Presentation"],
    [FileTypes.Spreadsheet, "Spreadsheet"],
    [FileTypes.TextDocument, "Text Document"]
]);
